/* eslint-disable no-restricted-syntax */
import Moment from 'moment';
import { extendMoment } from 'moment-range';

import { convertToMoneyAfterVat } from 'reports/utils';

const moment = extendMoment(Moment);

export function convertGroupedDataToColumnChartData(data, datesSelected, key) {
  const retObj = {};
  const range = moment.range(datesSelected.fromDate, datesSelected.toDate);

  for (const day of range.by('day')) {
    retObj[day.format('ddd')] = 0;
  }

  data.forEach((group) => {
    retObj[moment(group.date).format('ddd')] = convertToMoneyAfterVat(group[key]);
  });
  return retObj;
}

export function convertGroupedDataToLinearChartData(data, key, multiplier = 1) {
  const retObj = [];

  data.forEach((group) => {
    retObj.push([moment(group.date).format('ddd'), convertToMoneyAfterVat(group[key] * multiplier)]);
  });

  return retObj;
}

export function getSumOfGroupedData(data) {
  let sum = 0;
  data.forEach((group) => {
    sum += group.total;
  });

  return sum;
}

export function convertSalesGroupedDataToPieChartData(data) {
  const retObj = {};
  data.forEach((item) => {
    retObj[item.name] = convertToMoneyAfterVat(item.total);
  });

  return retObj;
}

export function completeMissingDatesInGroupedData(data, datesSelected) {
  const retObj = [];
  const range = moment.range(datesSelected.fromDate, datesSelected.toDate);

  const keys = data[0] ? Object.keys(data[0]) : [];

  for (const day of range.by('day')) {
    const date = day.format('YYYY-MM-DD');
    const serverData = data.find((grp) => grp.date === date);
    if (serverData) {
      retObj.push(serverData);
    } else {
      const objToPush = {};
      keys.forEach((key) => {
        objToPush[key] = 0;
      });
      objToPush.date = date;

      retObj.push(objToPush);
    }
  }

  return retObj;
}
